import { ErrorType, Field } from './enums'
import colors from 'tailwindcss/colors'

function getFormError(type: ErrorType, field?: Field): string | undefined {
  if (field === Field.EMAIL) {
    if (type === ErrorType.PATTERN) {
      return 'Please enter a valid email address'
    } else if (type === ErrorType.REQUIRED) {
      return 'Email address is required'
    }
  } else if (field === Field.PASSWORD) {
    if (type === ErrorType.REQUIRED) {
      return 'Password is required'
    }
  } else {
    if (type === ErrorType.REQUIRED) {
      return 'Required'
    }
  }
}

function formatPrice(value: number | string): string {
  const val = typeof value === 'string' ? parseFloat(value) : value
  return new Intl.NumberFormat('en-za', {
    style: 'currency',
    currency: 'ZAR'
  }).format(val)
}

export { getFormError, formatPrice }

export function arraysIntersect<T>(arr1: T[], arr2: T[]): boolean {
  return arr1.reduce((intersects, role) => {
    return intersects || arr2.includes(role)
  }, false as boolean)
}

interface Obj {
  [x: string]: any
  [y: number]: any
}

export function get(obj: Obj, path: string | number | string[], fallback?: any) {
  let key
  switch (typeof path) {
    case 'string':
      key = path.split('.')
      break
    case 'number':
      key = [path]
      break
    case 'object':
      key = path
      break
    default:
      key = path
  }

  for (let index = 0; index < key.length; index += 1) {
    if (!obj) break
    obj = obj[key[index]]
  }

  return obj === undefined ? fallback : obj
}

export function isNumber(val: any) {
  return typeof val === 'number'
}

/* Returns the tailwind equivalent classname of a color */
export function getColor(color: string, intensity: number): string {
  if (Object.keys(colors).includes(color) && typeof (colors as any)[color] === 'object') {
    return `${color}-${intensity}`
  }

  return color
}
